import React from 'react';
import { LeftPanelPageBaseLeftComponentStyle as S } from './LeftPanelPageBaseLeftComponent.style';
import { LeftPanelPageBaseLeftComponentItem } from './components/LeftPanelLayoutLeftComponentItem/LeftPanelPageBaseLeftComponentItem';

export const LeftPanelPageBaseLeftComponent: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.ContentScroll>
          <S.Scroll>
            <S.Items>
              <LeftPanelPageBaseLeftComponentItem
                title="Start unlocking insights today."
                description="Import your data to start exploring in Yabble’s secure environment. Use your 90-day Yabble trial to unlock unlimited access to your new AI research assistant, Gen."
              />
              <LeftPanelPageBaseLeftComponentItem
                title="3000 credits to immediately access insights."
                description="Use your complimentary credits to delve deeper into the Yabble tools with Count, Summarize or Virtual Audiences."
              />
              <LeftPanelPageBaseLeftComponentItem
                title="Easy credit card payment."
                description="You’ll be asked for your billing information when you sign up to make use of your $1,000 offer."
              />
            </S.Items>
          </S.Scroll>
        </S.ContentScroll>
      </S.Content>
      <S.BlackSection />
    </S.Container>
  );
};
